module.exports = __webpack_public_path__ + "media/images/cart-dfc1eaf4df0abdb77264fac5bfc28813.png";